// @ts-check
import { Box, Button, StarIcon, Text, Link } from '~/design-system';
import { Trans } from '@lingui/macro';
import { useCommonLinks } from '../../pages/imports/_config';
import MailToButton from '../MailToButton';
import Layout from '../Layout/Layout';
import PageSubtitle from '../Layout/PageSubtitle';
import PageTitle from '../Layout/PageTitle';

/**
 * Renders when error state is set in data import
 * @param {Object} props
 * @param {Object} [props.importData] - the import data
 */
export default function DefaultImportWithErrorPage({ importData }) {
  const link = useCommonLinks();
  return (
    <Layout>
      <Box sx={{ textAlign: 'center' }}>
        <StarIcon sx={{ height: 120, width: '120px' }} />
        <PageTitle>
          <Trans>Error</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>Sorry, an error occured processing the import.</Trans>
        </PageSubtitle>
        {importData?.outputUrl && (
          <Link target="_blank" href={importData.outputUrl}>
            <Trans>Download errors report</Trans>
          </Link>
        )}
        <Box sx={{ marginTop: 3 }}>
          <Text variant="default">
            <Button variant="secondary" to={link.root()}>
              <Trans>View imports</Trans>
            </Button>
            <MailToButton
              sx={{ marginLeft: 2 }}
              variant="primary"
              email="support@bottlebooks.me"
              subject="There was an error during import."
            >
              <Trans>Contact support</Trans>
            </MailToButton>
          </Text>
        </Box>
      </Box>
    </Layout>
  );
}
